<mat-progress-spinner
  class="spinner"
  mode="indeterminate"
  *ngIf="!responseResult">
</mat-progress-spinner>

<section *ngIf="responseResult" class="profile-results-exercises">
  <div class="profile-results-exercises__back" (click)="backOnLesson()">
    <span><img src="/assets/images/arrow_left.svg" alt="<--"></span>
    <span>Назад</span>
  </div>

  <ng-container *ngIf="responseResult.boxes.length > 0">
    <div *ngFor="let box of responseResult.boxes"  class="cards-container profile-results-exercises__box">
      <div *ngFor="let card of box.cards_results" class="profile-results-exercises__box__card" [ngClass]="getCardStyle(box.cards_format)">
        <div>
          <div class="profile-results-exercises__box__card__header">
            <span class="profile-results-exercises__box__card__header__extra">
              <span>№ {{ card.card_number }}</span>
              <span>
                  <ng-container *ngFor="let star of card.stars">
                    <img src="{{ star.type_achievement?.star }}" alt="{{ star.type_achievement?.title }}"
                      (click)="showStarModal(star)">
                  </ng-container>
              </span>
            </span>
            <span class="profile-results-exercises__box__card__header__hint">{{ card.hint }}</span>
          </div>
          <div  class="profile-results-exercises__box__card__exercises">
            <div *ngFor="let exercise of card.exercises_results; let i=index">

              <div *ngIf="exercise.exercise_type == calculation || exercise.exercise_type == insert"
                  class="exercise-calculation profile-results-exercises__box__card__exercises__item" [ngClass]="getTaskSpacingStyle(i)">
                <span class="profile-results-exercises__box__card__exercises__item__number">{{i + 1}})&nbsp;&nbsp;</span>
                <span>
                  <ng-katex-paragraph
                    class="katex text katex-p"
                    [paragraph]="exercise.exercise_text | exerciseFormat:'text'">
                  </ng-katex-paragraph>
                </span>
                <span>&nbsp;&nbsp;</span>
                <span [class.exercise-answer-right]="exercise?.correct" [class.exercise-answer-wrong]="!exercise?.correct">
                  <ng-katex-paragraph
                    class="katex text"
                    [paragraph]="exercise.shortAnswer | exerciseFormat:'text'">
                  </ng-katex-paragraph>
                </span>
                <span *ngIf="!exercise?.correct" class="exercise-answer-right-after-wrong">
                  <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                  <span>
                    <ng-katex-paragraph
                      class="katex text katex-p"
                      [paragraph]="exercise.exercise_correct_answers[0].shortAnswer | exerciseFormat:'text'">
                    </ng-katex-paragraph>
                  </span>
                </span>
              </div>

              <div *ngIf="exercise.exercise_type == task || exercise.exercise_type == logic" class="exercise-task" [ngClass]="getTaskSpacingStyle(i)">
                <div>
                  <span class="profile-results-exercises__box__card__exercises__item__number">{{i + 1}})&nbsp;&nbsp;</span>
                  <span>
                    <ng-katex-paragraph
                      class="katex text katex-p"
                      [paragraph]="exercise?.exercise_text | exerciseFormat:'text'">
                    </ng-katex-paragraph>
                  </span>
                  <ng-container *ngIf="exercise.answer_by_question && exercise.answer_by_question.length > 0">
                    <span class="exercise-text" *ngFor="let question of exercise.answer_by_question">
                      <ng-katex-paragraph
                        class="katex text katex-p"
                        [paragraph]="question.text | exerciseFormat:'text'">
                      </ng-katex-paragraph>
                    </span>
                  </ng-container>
                </div>
                <div class="exercise-task-answer-header">
                  <span>Ответ:    </span>
                  <span class="exercise-task-answer-header__answer_and_correct">
                    <ng-container *ngIf="exercise.answer_by_question && exercise.answer_by_question.length > 0">
                      <ng-container *ngFor="let question of exercise.answer_by_question; let n=index">
                        <span *ngIf="n > 0">,&nbsp;</span>
                        <span *ngFor="let studentAnswer of question.student_answers; let p=index"
                            [class.exercise-answer-right]="studentAnswer.shortAnswer == question.answers[p].shortAnswer"
                            [class.exercise-answer-wrong]=" studentAnswer.shortAnswer != question.answers[p].shortAnswer">
                          <span *ngIf="p > 0">,&nbsp;</span>
                          <span>&nbsp;&nbsp;</span>
                          <ng-katex-paragraph
                            class="katex text"
                            [paragraph]="studentAnswer.shortAnswer | exerciseFormat:'text'">
                          </ng-katex-paragraph>
                        </span>
                      </ng-container>
                      <span *ngIf="!exercise?.correct" class="exercise-answer-right-after-wrong">
                        <ng-container *ngFor="let question of exercise.answer_by_question; let n=index">
                          <span *ngIf="n > 0">,&nbsp;</span>
                          <span *ngFor="let answer of question.answers; let k=index">
                            <span *ngIf="k > 0">,&nbsp;</span>
                            <span>
                              <ng-katex-paragraph
                                class="katex text"
                                [paragraph]="answer.shortAnswer | exerciseFormat:'text'">
                              </ng-katex-paragraph>
                            </span>
                          </span>
                        </ng-container>
                      </span>
                    </ng-container>
                  </span>
                  <span>
                    <ng-container *ngIf="!(exercise.answer_by_question && exercise.answer_by_question.length > 0)">
                      <span
                        [class.exercise-answer-right]="exercise.shortAnswer == exercise.exercise_correct_answers[0].shortAnswer"
                        [class.exercise-answer-wrong]="exercise.shortAnswer != exercise.exercise_correct_answers[0].shortAnswer">
                        <ng-katex-paragraph
                          class="katex text katex-p"
                          [paragraph]="exercise.shortAnswer | exerciseFormat:'text'">
                        </ng-katex-paragraph>
                      </span>
                      <span *ngIf="!exercise?.correct" class="exercise-answer-right-after-wrong">
                        <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                        <ng-container *ngFor="let rightAnswer of exercise.exercise_correct_answers; let n=index">
                          <span *ngIf="n > 0">,&nbsp;</span>
                          <span>
                            <ng-katex-paragraph
                              class="katex text katex-p"
                              [paragraph]="rightAnswer.shortAnswer | exerciseFormat:'text'">
                            </ng-katex-paragraph>
                          </span>
                        </ng-container>
                      </span>
                    </ng-container>
                  </span>
                </div>
              </div>

              <div *ngIf="exercise.exercise_type == magic_box" >
                <table class="magic-box">
                  <tr *ngFor="let row of getMagicBoxObject(exercise.exercise_text); let magic_row=index">
                    <td *ngFor="let elem of row; let magic_elem=index" [ngClass]="getMagicBoxTdStyle(elem,exercise,magic_row,magic_elem)">
                      <div *ngIf="elem != null" class="magic-box-cell-task">{{ elem }}</div>
                      <div *ngIf="elem == null && compareMagicBoxAnswers(exercise,magic_row,magic_elem)" class="magic-box-cell-right">{{ getMagicBoxCellRight(exercise,magic_row,magic_elem) }}</div>
                      <div *ngIf="elem == null && !compareMagicBoxAnswers(exercise,magic_row,magic_elem)"><span class="magic-box-cell-right-above-wrong">{{ getMagicBoxCellRight(exercise,magic_row,magic_elem) }}</span><span class="magic-box-cell-wrong">{{ getMagicBoxCellWrong(exercise,magic_row,magic_elem) }}</span></div>
                    </td>
                  </tr>
                </table>
              </div>

              <div *ngIf="exercise.exercise_type == sequence" class="exercise-sequence" [ngClass]="getTaskSpacingStyle(i)">
                <span class="profile-results-exercises__box__card__exercises__item__number">{{i + 1}})&nbsp;&nbsp;</span>
                <span>
                  <ng-katex-paragraph
                    class="katex text katex-p"
                    [paragraph]="exercise?.exercise_text | exerciseFormat:'text'">
                  </ng-katex-paragraph>
                </span>
                <span>&nbsp;&nbsp;</span>
                <span
                  [class.exercise-answer-right]="exercise?.correct"
                  [class.exercise-answer-wrong]="!exercise?.correct">
                  <ng-katex-paragraph
                    class="katex text"
                    [paragraph]="exercise.shortAnswer | exerciseFormat:'text'">
                  </ng-katex-paragraph>
                </span>
                <span *ngIf="!exercise?.correct" class="exercise-answer-right-after-wrong">
                  <span>&nbsp;</span>
                  <span>
                    <ng-katex-paragraph
                      class="katex text"
                      [paragraph]="exercise?.exercise_text | exerciseFormat:'text'">
                    </ng-katex-paragraph>
                  </span>
                  <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                  <span>
                    <ng-katex-paragraph
                      class="katex text"
                      [paragraph]="exercise.exercise_correct_answers[0].shortAnswer | exerciseFormat:'text'">
                    </ng-katex-paragraph>
                  </span>
                </span>
              </div>

              <div *ngIf="[puzzle_task, puzzle_example].includes(exercise.exercise_type)">
                <app-exercise-puzzle
                  [exercise]="exercise"
                  [index]="i"
                  [viewType]="'analytics_modal'"
                  [currentAnswer]="exercise.shortAnswer">
                </app-exercise-puzzle>
              </div>

            </div>
            <div *ngIf="card.is_correct_extra_exercise_result !== null" class="extra_exercise">
              <span>Доп. задание: </span>
              <span>{{ card.is_correct_extra_exercise_result ? "+" : "-" }}</span>
            </div>

          </div>
        </div>
        <div class="profile-results-exercises__box__card__footer">
          <div class="money-amount">
            {{getMoneyAmount(card.clear_reward)}}
          </div>
          <div *ngIf="box.smart_sprints > 0" class="smart-sprint">
            Время: <b style="color: #4e77af">{{ convertSecondToMinute(card) }}</b>
          </div>
          <span class="profile-results-exercises__box__card__footer__box_number">Бокс {{ box.title }}</span>
        </div>
      </div>
    </div>
  </ng-container>

</section>


<ng-container *ngIf="toggleStarModal">
  <app-profile-results-star-description
    [starImg]="starData.type_achievement.star"
    [title]="starData.type_achievement.title"
    [explanation]="starData.explanation"
    [exercises]="starData.exercises_results"
    (showModal)="starModal()">
  </app-profile-results-star-description>
</ng-container>
